import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography} from "@mui/material";
import {useMutation} from "@apollo/client";
import {useState} from "react";
import {useTranslation} from "react-i18next";

import {DELETE_AMENDMENT} from "../../queries/GraphQLQueries";
import CustomAlert from "../CustomAlert";

const styles = {
    dialog: {
        actions: {
            padding: "1rem",
            paddingTop: 0
        },
        content: {
            padding: "1rem",
        },
        title: {
            padding: "1rem",
        },
    },
};

export default function DeleteAmendmentDialog({open, onClose, amendment, onAmendmentDeleted}) {
    const {t} = useTranslation();
    const [deleteAmendment, {loading: isDeletingAmendment}] = useMutation(DELETE_AMENDMENT);
    const [alertMessage, setAlertMessage] = useState(null);

    const handleCloseCustomAlert = () => setAlertMessage(null);

    const handleDeleteAmendment = () => {
        if (!amendment?.id || isDeletingAmendment) {
            return;
        }
        setAlertMessage({children: t("deleteAmendmentDialog.deletingAmendment"), severity: "success"});

        deleteAmendment({
            variables: {
                id: amendment.id,
            },
        }).then(() => {
            onAmendmentDeleted?.();
            onClose();
        }).catch((error) => {
            setAlertMessage({children: error?.message, severity: "error"});
            console.error(error);
        })
    }

    return (
        <>
            <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
                <DialogTitle sx={styles.dialog.title}>
                    {t("deleteAmendmentDialog.title")}
                </DialogTitle>

                <DialogContent sx={styles.dialog.content}>
                    <Typography variant="body1">
                        {t("deleteAmendmentDialog.confirmationMessage")}
                    </Typography>
                </DialogContent>

                <DialogActions sx={styles.dialog.actions}>
                    <Button onClick={onClose} variant="contained" disabled={isDeletingAmendment}>
                        {t("common.cancelLabel")}
                    </Button>

                    <Button
                        onClick={handleDeleteAmendment}
                        variant="contained"
                        color="error"
                        disabled={isDeletingAmendment || !amendment?.id}>
                        {t("common.deleteLabel")}
                    </Button>
                </DialogActions>
            </Dialog>
            <CustomAlert alertMessage={alertMessage} handleCloseCustomAlert={handleCloseCustomAlert}/>
        </>
    )
}